import styled from "styled-components";

export const AlertWrapper = styled.div`
  display: flex;
  @media (max-width: 680px) {
    position: fixed;
    top: 0;
  }
  .info {
    display: none;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize.xxs};

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${({ theme }) => theme.fontSize.xs};
    margin-left: ${({ theme }) => theme.space.xs};
  }
`;

export const DivWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
  justify-content: center;
  white-space: nowrap;
  padding-top: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    margin-left: ${({ theme }) => theme.space.md};
    margin-top: 0;
  }
`;
